var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.item.path)?_c('router-link',{class:{ active: _vm.active },attrs:{"to":_vm.path},domProps:{"innerHTML":_vm._s(_vm.itemName)}}):(_vm.item.link)?_c('a',{attrs:{"href":_vm.item.link},domProps:{"innerHTML":_vm._s(_vm.itemName)}}):_c('a',{domProps:{"innerHTML":_vm._s(_vm.itemName)}})
}
var staticRenderFns = []

export { render, staticRenderFns }